// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/SearchForEmail/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Email_NewEmail_Content_SearchForEmail_Content($address: String!) {
  vaxiom_contact_emails(where: { address: { _eq: $address } }) {
    id
    contact_method {
      id
      association {
        id
        person {
          id
          first_name
          last_name
        }
      }
    }
  }
}

`